<template>
  <svg viewBox="0 0 30 30">
    <path
      d="M22.371,4.158c1.65,0,3,1.35,3,3v15.684c0,1.65-1.35,3-3,3H7.629c-1.65,0-3-1.35-3-3V7.158c0-1.65,1.35-3,3-3H22.371z" />
  </svg>
</template>